// @flow

import * as React from "react";
import RenderHTML from "../components/RenderHTML";

type PropsType = {
    errors: Array<string>,
};

const ServerError = (props: PropsType): React.Node => {
    if (props.errors.length > 0) {
        return (
            <div className="server-error">
                <div className="server-error__icon">
                    <i className="icon icon-alert-triangle"></i>
                </div>
                <div className="server-error__errors">
                    <div className="server-error__title">
                        <strong>
                            There were errors with the form, please review the
                            below:
                        </strong>
                    </div>
                    {props.errors.length === 1 ? (
                        <RenderHTML markup={props.errors[0]}></RenderHTML>
                    ) : (
                        <ul>
                            {props.errors.map(
                                (error: string, index: number): React.Node => (
                                    <li key={index}>
                                        <RenderHTML markup={error}></RenderHTML>
                                    </li>
                                )
                            )}
                        </ul>
                    )}
                </div>
            </div>
        );
    }
    return null;
};

export default ServerError;
